import { render, staticRenderFns } from "./ReserveBillForm.vue?vue&type=template&id=036b7356&scoped=true&"
import script from "./ReserveBillForm.vue?vue&type=script&lang=js&"
export * from "./ReserveBillForm.vue?vue&type=script&lang=js&"
import style0 from "./ReserveBillForm.vue?vue&type=style&index=0&id=036b7356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b7356",
  null
  
)

export default component.exports